export const normalizeIsValidModalityAccount = (
  value: boolean | null | undefined,
): boolean | null => (typeof value === 'boolean' ? value : null)
